import {lazy} from 'react';

export const foundryPagesConfigs = [
  {
    auth: ['user'],
    routes: [
      {
        // More specific route with param must come first
        path: '/foundry/chat/:threadId',
        component: lazy(() => import('./chat/FoundryChat')),
      },
      {
        // Base route comes second (acts as fallback)
        path: '/foundry/chat',
        component: lazy(() => import('./chat/FoundryChat')),
      },
    ],
  },
];
